import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import LinesEllipsis from 'react-lines-ellipsis';
import {
    TextOverflow,
} from './DynamicOverflowTip.style';
export default class DynamicOverflowTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToolTip: false,
      checked: false,
    };
    this.lessonRef = React.createRef(null);
  }

  componentDidMount() {
    this.initTooltip();
  }

  componentDidUpdate() {
    this.initTooltip();
  }

  initTooltip = () => {
    if (this.lessonRef?.current && !this.state.checked) {
      this.setState({
        showToolTip: !!this.lessonRef.current.clamped,
        checked: true,
      });
    }
  };

  render() {
    const { showToolTip } = this.state;
    const { title, lines, large, subject } = this.props;
    return (
        <Tooltip
            enterDelay={500}
            title={title}
            disableHoverListener={!showToolTip}
        >
        <TextOverflow large={large} subject={subject}>
         {
           lines != null ? <LinesEllipsis
           ref={this.lessonRef}
           text={title}
           maxLine={lines}
           basedOn="letters"
           component="span"
           /> : title
         }
     </TextOverflow> 
      </Tooltip>
    );
  }
}
